 import arrowleft from "@Images/NewUI/Vector.png";
import "@Styles/mandate.css";
import moment from "moment";
import React, { useEffect, useRef, useState } from "react";
import { connect } from "react-redux";
import { useNavigate } from "react-router-dom";
import Spinner from 'react-spinner-material';
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import 'toolcool-range-slider';
import DisclaimerImg from "../../../Images/NewUI/disclaimer.png";
import Downward from "../../../Images/NewUI/downward.png";
import {
  applyForLoan,
  create_ckyc,
  getLoanCalculation,
  getReasonForLoan,
  getRepaymentDate
} from "../../../Redux/ApplyLoan/action";
import { getDocumentStatus } from "../../../Redux/Manual_Kyc_Details/action";
import { withRouter } from "../../../hooks/withRouter";
import ToastMsg from "../../../helper/ToastMsg";
import { Loader } from "../Common/Loader";


const options = {
  position: "top-center",
  autoClose: 2000,
  limit: 1,
  closeButton: false,
};

const ApplyLoan = (props) => {
  const navigate = useNavigate();
  const token = localStorage.getItem("gpay_token");
  const [isReasonOpen, setIsReasonOpen] = useState(false);
  const [selectedReason, setSelectedReason] = useState("");
  const [loan_type, setLoanType] = useState("");
  const [loanAmount, setLoanAmount] = useState("");
  const [repayment_date, setRepaymentDate] = useState([]);
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);
  const [processing_fee, setProcessing_fee] = useState("");
  const [gst, setGst] = useState("");
  const [loader, setLoader] = useState(false);
  const [processing_fee_less_1000_amount, setProcessing_fee_less_1000_amount] =
    useState(100);
  const [processing_above_2000, setProcessing_above_2000] = useState("");
  const [gst_above_2000, setGst_above_2000] = useState("");
  const [gst_below_1000, setGst_below_1000] = useState(18);
  const [gst_between_1000_2000, setGst_between_1000_2000] = useState("");
  const [tpf_above_2000, setTpf_above_2000] = useState("");
  const [tpf_below_1000, setTpf_below_1000] = useState(118);
  const [tpf_between_1000_2000, setTpf_between_1000_2000] = useState("");
  const [tenure_days, setTenure_days] = useState("");
  const [processing_between_1000_2000, setProcessing_between_1000_2000] =
    useState("");
  const [repayment_amount, setRepayment_amount] = useState("");
  const [rate_of_interest, setRate_of_interest] = useState("");
  const [emi_repayement_amount, setEmi_repayement_amount] = useState("");
  const [processing_fee_1000_2000, setProcessing_fee_1000_2000] = useState("");
  const [repayDate, setRepayDate] = useState("");
  const [repayment_date_options_emi, setRepayment_date_options_emi] =
    useState("");
  const [emiDate, setEmiDate] = useState([]);
  const [loanReason, setLoanReason] = useState("");
  const [maxLoanMaount, setMaxLoanMaount] = useState(0);
  const [erroramount, setErroramount] = useState("");
  const [toastLimit, setToastLimit] = useState(true);
  const [reasonList, setReasonList] = useState([]);
  const [slidercheck, setSlidercheck] = useState(false);
  const [step, setStep] = useState("0");
  const from_deeplink= localStorage.getItem("from_deeplink");
  const [loanCalculations, setLoanCalculations] = useState({});
  const [spinner, setSpinner] = useState(false);
  const [repaymentData, setRepaymentData] = useState([]);
    const [emiList, setEmiList] = useState([]);
    const [selectedDate, setSelectedDate] = useState("");
    const [isOpen, setIsOpen] = useState(false);
    const [isRepaymentOpen, setIsRepaymentOpen] = useState(false);
    const [intLoanAmout, setIntLoanAmout] = useState(0);
    
    



    const [isLoanTypeOpen, setIsLoanTypeOpen] = useState(false);
const [selectedLoanType, setSelectedLoanType] = useState("");
const [selectedLoanTypeDescription, setSelectedLoanTypeDescription] = useState("");
const [payday_visible, setPayday_visible] = useState(false);
const [maxLoanAmount, setMaxLoanAmount] = useState(0);

const [userCreditList, setUserCreditList] = useState([]);
    
 

  useEffect(() => {
    if(maxLoanAmount ==0){
      setLoanAmount("")
      setIntLoanAmout("");
    }
     
    
  }, [loanAmount, intLoanAmout]);

useEffect(() => {
  const slider = sliderRef.current;

  if (slider) {
    const handleTouchStart = (e) => {
      setLoanAmount(Number(e.target.value));
      setIntLoanAmout(Number(e.target.value));
    };

    const handleTouchEnd = (e) => {
      setLoanAmount(Number(e.target.value));
      setIntLoanAmout(Number(e.target.value));
    };

    const handleTouchMove = (e) => {
      setLoanAmount(Number(e.target.value));
      setIntLoanAmout(Number(e.target.value));
    };

    slider.addEventListener('touchstart', handleTouchStart);
    slider.addEventListener('touchend', handleTouchEnd);
    slider.addEventListener('touchmove', handleTouchMove);

    // Cleanup event listeners on component unmount
    return () => {
      slider.removeEventListener('touchstart', handleTouchStart);
      slider.removeEventListener('touchend', handleTouchEnd);
      slider.removeEventListener('touchmove', handleTouchMove);
    };
  }
}, [setLoanAmount, setIntLoanAmout]);

  useEffect(() => {
    
    var creditList =  props.userDetail?.user_detail?.customusermodel?.usercredit;
    // for (i==0 , i++, i < creditList.length ) {
    //   if()
    // }
    const OnlyEmiCreditList = creditList.filter((cred) => cred.loan_type !== "P");
    setUserCreditList(OnlyEmiCreditList)
    const userLevel =
      props.userDetail?.user_detail?.customusermodel?.user_level;
    let {
      processing_fee,
      processing_fee_1000_2000,
      processing_fee_less_1000_amount,
      rate_of_interest,
      gst,
    } = userLevel ? userLevel : "";

    // this.setState({
      
    handleReasonForLoan();
    setProcessing_fee(processing_fee);
    setProcessing_fee_less_1000_amount(processing_fee_less_1000_amount);
    setRate_of_interest(rate_of_interest);
    setProcessing_fee_1000_2000(processing_fee_1000_2000);
    setGst(gst);
 
  
  }, []);

  const handleLoanTypeSelect = (loanType, creditLimit, description) => {
    setSelectedLoanType(loanType);
    setSelectedLoanTypeDescription(description);
    setIsLoanTypeOpen(false);
    setPayday_visible(false);
    fetchRepaymentDate(loanType);
    setMaxLoanMaount(creditLimit);
    setLoanAmount(0);
    localStorage.setItem("loan_type_description", description);
  };


  const handleGetLoanCalculation = (loanAmount, repayDate) => {
    setSpinner(true)
    const token = localStorage.getItem("gpay_token");
    
    let data = {
      "loan_type": loan_type,
      "amount": loanAmount,  
      "repayment_date": repayDate 
    };
    props
      .getLoanCalculation(data, token)
      .then((res) => {
        setSpinner(false)
        const responseData = res?.data;
      
        setLoanCalculations(responseData)
        setEmiList(responseData?.repayment_schedule )
        
      })
      .catch((err) => {
        console.log(err);
      });
  }

  const handleReasonForLoan = () => {
 
    props
      .getReasonForLoan(token)
      .then((res) => {
        if (res.status === 200) {
          setReasonList(res.data.data);
        }
      })
      .catch((err) => {
        setLoader(false);
        if (err.response?.status === 401) {
         window.location.href = "/";
          localStorage.removeItem("gpay_token");
          
        }
        let error = err?.response?.data?.error;
        ToastMsg(error, "error");
      });
  };

  const notify = (err) => {
    toast.error(err, { ...options });
  };
 

  const handleChange = (e) => {
    const re = /^[0-9\b]+$/;  
  
    if (e.target.value === "" || re.test(e.target.value)) {
      const value = Number(e.target.value);
      if (value <= maxLoanAmount) {
        setIntLoanAmout(e.target.value)
        setLoanAmount(e.target.value);
      } else {
        setIntLoanAmout(maxLoanAmount)
        setLoanAmount(maxLoanAmount);
      }
      if (loanAmount && repayDate) {
        setPayday_visible(!payday_visible);
        handleCalculation();
      } else {
        setPayday_visible(false);
      }
    }
  };
  

  const saveReasonForLoan = (reason) => {
    setLoanReason(reason);
  };

  const fetchRepaymentDate = (loan_type) => {
    setSlidercheck(true)
    setStep("100")
    // console.log(slidercheck, "jigar");
    setLoanType(loan_type);

    if (loan_type !== "") {
      props
        .getRepaymentDate(loan_type, token)
        .then((res) => {
          if (res?.repayment_date_options?.length === 0) {
           // localStorage.setItem("loan_type_description",temp[2])
            setIsButtonDisabled(true);
            setRepayDate(res?.repayment_date[0]);
            setEmiDate(res?.repayment_date);
            
          }
          setRepaymentDate(res.repayment_date_options);
          setRepayment_date_options_emi(res.repayment_date_options_emi);
          if (!res.repayment_date_options == {}) {

                        res.repayment_date_options.map((item, key) => {
            
                            let current_date = moment(new Date());
                            let new_date = moment(item).format("YYYY-DD-MM");
            
                            let tenure = moment(new_date).diff(moment(current_date), "days") > 0
                                ? moment(new_date).diff(moment(current_date), "days")
                                : 0;
            
                            setTenure_days(tenure + 1);
                        });
                    }
                    else {
                        let date1 = moment(res?.repayment_date[0]).format("YYYY-MM-DD")
                        let temp = moment(date1).diff(moment(new Date()), "days")
                        if(!repayDate){
                            setTenure_days(temp + 1)
                        }
        }
      })
        .catch((err) => {
          setLoader(false);
          if (err.response?.status === 401) {
           window.location.href = "/";
          localStorage.removeItem("gpay_token");
          }
          let error = err?.response?.data?.error;
          ToastMsg(error, "error");
          // console.log(err);
        });
    } else {
      setRepaymentDate([]);
      setRepayment_date_options_emi("");
    }
  };
  const setRepayment = (e) => {
    setRepayDate(e);
    if (e !== "") {
      setIsButtonDisabled(true);
    } else {
      setIsButtonDisabled(false);
    }
  };
  const processingFeeCalculation = () => {
    if (loanAmount > 2000) {
      let cal = Math.round((parseInt(loanAmount) * processing_fee) / 100);
      let gst_cal = (cal * gst) / 100;
      let tpf = cal + gst_cal;
      setProcessing_above_2000(cal);
      setGst_above_2000(gst_cal);
      setTpf_above_2000(tpf);
    } else if (loanAmount <= 1000) {
    } else if (1000 < loanAmount < 2000) {
      let result = Math.round((parseInt(loanAmount) * processing_fee) / 100);
      let gst_calulation = (result * gst) / 100;
      let tpf_2000 = result + gst_calulation;
      setProcessing_between_1000_2000(result);
      setGst_between_1000_2000(gst_calulation);
      setTpf_between_1000_2000(tpf_2000);
    }
    setIsButtonDisabled(true);
  };
  const handleReasonSelect = (reason) => {
    setSelectedReason(reason);
    saveReasonForLoan(reason);
    setIsReasonOpen(false);
  };
  const calculateTenureDays = () => {
    if (repayment_date) {
      repayment_date.map((item, key) => {
        let date = new Date();
        let current_date = moment(date).format("YYYY-MM-DD");
        let new_date = moment(item).format("YYYY-MM-DD");
        let tenure =
          moment(new_date).diff(moment(current_date), "days") > 0
            ? moment(new_date).diff(moment(current_date), "days")
            : 0;
        setTenure_days(tenure + 1);
      });
    }
  };


  const sliderRef = useRef(null);

  useEffect(() => {

      const slider = sliderRef.current;

      const onChange = (evt) => {
        setPayday_visible(false);
          const customEvent = evt ;
          setLoanAmount(customEvent.detail.value)
      };
      slider?.addEventListener('change', onChange);

      return () => {
        slider?.removeEventListener('change', onChange);
      };
  }, []);
  
  const calculateRepaymentAmount = () => {

    let result = (parseInt(loanAmount) * rate_of_interest * (tenure_days + 1)) / 100;
    setRepayment_amount(parseInt(result) + parseInt(loanAmount))
};
const calculateEmiRepaymentAmount = () => {

    let month = loan_type.length === 3
        ? loan_type.substr(loan_type.length - 2)
        : loan_type.substr(loan_type.length - 1);
    const roi = (30 * rate_of_interest) / 100;

    const result = Math.round(loanAmount * ((roi * (1 + roi) ** month) / ((1 + roi) ** month - 1)));
    setEmi_repayement_amount(result);


};

useEffect(() => {
  const storedLoanType = localStorage.getItem("loan_type");
  const storedLoanAmount = localStorage.getItem("loanAmount");
  const storedLoanReason = localStorage.getItem("loanReason");
  const storedRepaymentDate = localStorage.getItem("repayDate");
  const storedLoanTypeDescription = localStorage.getItem("loan_type_description");

  if (storedLoanType && storedLoanAmount && storedLoanReason) {
    let parsedLoanAmount = Number(storedLoanAmount);

    const matchingLoan = userCreditList.find(item => item.loan_type === storedLoanType);
    const correctMaxLoanAmount = matchingLoan ? matchingLoan.credit_limit : 0;

    setMaxLoanAmount(correctMaxLoanAmount);

    handleSelect(storedLoanType, correctMaxLoanAmount, storedLoanTypeDescription || storedLoanType);

    setSelectedReason(storedLoanReason);
    setLoanReason(storedLoanReason);

    if (parsedLoanAmount > correctMaxLoanAmount) {
      parsedLoanAmount = correctMaxLoanAmount;
    }

    setLoanAmount(parsedLoanAmount);
    handleDateSelect(storedRepaymentDate)
    // setSelectedDate(storedRepaymentDate)
    setIntLoanAmout(parsedLoanAmount);

    setTimeout(() => {
      if (sliderRef.current) {
        sliderRef.current.value = parsedLoanAmount;
      }
    }, 100);
  }
}, [userCreditList]);



useEffect(() => {
  if (userCreditList.length === 1) {
    const item = userCreditList[0];
    handleSelect(item.loan_type, item.credit_limit, item.description);
  }
}, [userCreditList]); 

const handleSelect = (loanType, creditLimit, description) => {
  setMaxLoanAmount(creditLimit);
  console.log("Max Loan Amount:", creditLimit);
  setSelectedLoanType(description);
  setIsOpen(false);
  setPayday_visible(false);
  fetchRepaymentDate(loanType);
  
  if (userCreditList.find(item => item.loan_type === loanType)) {
    setLoanAmount(0);
  } else {
    setLoanAmount(creditLimit); 
  }

  localStorage.setItem("loan_type_description", description);
};

useEffect(() => {
  console.log(maxLoanAmount , "updattee");
}, [maxLoanAmount]);

const handleDateSelect = (date) => {
  setSelectedDate(date);
  setRepayment(date);
  let formattedDate = moment(date).format("YYYY/MM/DD");
  let temp = moment(formattedDate).diff(moment(new Date()), "days");
  setPayday_visible(false);
  setTenure_days(temp + 1);
  setIsRepaymentOpen(false);
};



const calculateEmi = () => {
    Object.entries(repayment_date_options_emi).map(([key, value]) => {
        
        let date = moment(key).format("YYYY-MM-DD")
        if (date === repayDate) {

            setEmiDate(value);
        }
    });
};
const handleCalculation = () => {
  processingFeeCalculation();
  calculateRepaymentAmount();
  calculateEmiRepaymentAmount();
  calculateEmi();
  setPayday_visible(!payday_visible);
};

  const submitForm = () => {
    
   
    let temp = Number(1000) - Number(loanAmount);
    if (temp > 0) {
      notify(`Loan amount should be between 1000 to  ${maxLoanAmount}!`);
      return;
    } else {
      localStorage.setItem("loan_type", loan_type);
      localStorage.setItem("loanAmount", loanAmount);
      localStorage.setItem("repayDate", repayDate);
      localStorage.setItem("loanReason", loanReason);
      let data = {
        amount: loanAmount,
        loan_type: loan_type,
        reason_for_loan: loanReason,
        repayment_date: repayDate,
      };
      props.create_ckyc(data,token).then((res) => {
          setLoader(true);
          if (res.data.data.professional_details_verified === "VERIFIED" )
            {
          if (res?.data?.data?.kyc_verified == "PENDING_VERIFICATION") {
            setLoader(false);

            navigate("/kycverifyinprogress");
            return
          } 
          if (res?.data?.data?.kyc_verified == "NOT_VALID") {
            navigate("/kycnotdone");
            return
          }
          if (res?.data?.data?.kyc_verified === "NOT_SUBMITTED") {
            navigate("/manual_verify?keyfrom=apply_now");
            return
          } 
          props.getDocumentStatus(token).then((res) => {
            res.data.map((details) => {
              if (details.key_fact_screen === true) {
                navigate("/key-statements?keyfrom=Applyloan");
              } else {
                if(details.bank_details_verified == "NOT_VALID"){
                  let bankData = {
                    heading: "Sorry !",
                    subHeading: "Bank details could not be verified. Please try again",
                    message: "",
                    but_name: "Try Again",
                    route: "bank",
                    backbtn: "show"
                  };
          
                  navigate(
                    `/not_eligible_for_loan?msg=${JSON.stringify(bankData)}`
                  );
                  return;
                }
                if(details.bank_details_verified == "PENDING_VERIFICATION"){
                  let bankData = {
                    heading: "Please Wait!",
                    subHeading: "Please try after sometime",
                    message: "Your bank details are in pending verification.",
                    but_name: "Back to Home",
                    route: "bank",
                  };
          
                  navigate(`/message?details=${JSON.stringify(bankData)}`);
                  return;
                }
                if(details.bank_details_verified == "NOT_SUBMITTED"){
                  navigate("/add_bank_details")
                  return;
                }
                //props.history.push("/autodebit")
                if(res.data[0].emandate_verified === 'S'){
                  navigate("/loandetail")
                }
                if(res.data[0].esign_verified  === 'S' && res.data[0].emandate_verified === 'S'){
                  navigate( '/loandetail?someCheck=true')
                }
                else  {
                navigate("/autodebit");
                }
                //props.history.push("/agreement");
              }
            });
      });
    }
    else{
      navigate("/employment-details");
    }
        }).catch((err) => {
          setLoader(false);
          let error = err?.response?.data?.error || err?.response?.data?.message || "Something went wrong. Please try again.";
          ToastMsg(error, "error");
        })
     
    }
  };
  const [selectLoanType,setSeletLoanType]=useState('')
  
  const loanTypeHandle=(e)=>{
    let val=e.target.value;
    setSeletLoanType(val)
  }

  
  console.log(emiList , "resofhandlegetloancalculation");

 
  return (
    <>
      {
        loader ? (
          <Loader />
        ) : (
          <div className="main_div payme_body">
            <div className="toolbarRespo">
              <div className="ml-28 mt-10 shadowline  flex sticky-header align-center">
                <a
                  onClick={(e) => {
                    e.preventDefault();
                    from_deeplink
                      ? navigate("/super-loan-dashboard")
                      : navigate("/super-loan-dashboard")
                  }}
                >
                  <img src={arrowleft} style={{ marginRight: 40 }} />
                </a>
                <div>
                  <span className="paymecolour loanapplicationemi">EMI</span> <br/>
                  <span className="loanapplication">Loan Application</span>
                </div>
              </div>

              <div className=" aligncentrehere container">
                <div className="cardSeeCalculation mb-20 mt-24  pd-l-r-zeroNew container">
                <div>
      <span className="reasonforloanspan">Loan Type</span> <br />
      <div className="custom-dropdown-container">
        <div className="custom-dropdown mt-10imp mb-20" 
         onClick={() => {
          setIsReasonOpen(false);
          setIsOpen(!isOpen);
          // setIntLoanAmout("")
          // setLoanAmount("")
        }}
        >
          {selectedLoanType || "Select Loan Type"}
          <span className={`arrow ${isOpen ? "open" : ""}`}></span>
        </div>
        {isOpen && (
          <div className="custom-dropdown-menu-loantype">
            {userCreditList.length > 0
              ? userCreditList.map((item) => (
                <div
                  key={item.loan_type}
                  className="custom-dropdown-item outlinegeneral"
                  onClick={() => {
                    setLoanAmount("")
                    setIntLoanAmout("");
                    
                    handleSelect(item.loan_type, item.credit_limit, item.description);
                    
                  }}
                >
                  {/* {item.credit_limit} */}
                  {item.description}
                </div>
              ))
              : "No loan types available"}
          </div>
        )}
      </div>
    </div>
                </div>
                <div className="cardstructurerepay pd-l-r-zeroUpdate container">
                  <div className="flex_row justifycontent  align_flex_start">
                    <div className="flex_row ">
                      <div className="majorAmountdiv">
                        <div
                          style={{ marginBottom: 10 }}
                          className="flex_row align_centre"
                        >
                          {loan_type == "P" ? (
                            <span className="loanamountText ml-10 mt-16">
                              Select Loan Amount
                              {/* <span className="inrupee">(in ₹)</span> */}
                            </span>
                          ) : (
                            <span className="loanamountText ml-10 mt-16">
                              Select Loan Amount
                              {/* <span className="inrupee">(in ₹)</span> */}
                            </span>
                          )}
                        </div>
                      </div>
                    </div>

                    <div
                      style={{ marginRight: 10 }}
                      className="marginTop displayfix align_centre "
                    ></div>
                  </div>
                  <input
                    className="applyloanInput"
                    placeholder={`₹ ${maxLoanAmount}`}
                    name="loanAmount"
                    type="text"
                    value={loanAmount}
                    onChange={handleChange}
                  />
                  <div className="progressbar">
                    <div className="applyloanslider mt-10">
                    <toolcool-range-slider
                      disabled={!slidercheck}
                      max={maxLoanAmount}
                      ref={sliderRef}
                      min="1000"
                      step="100"
                      value={loanAmount}
                      slider-height="4px"
                       slider-bg-fill="#3BBE9D"
                      pointer-bg="#3BBE9D"
                      pointer-border="2px solid white"
                      slider-border="rgba(252, 102, 3, 0.1)"
                      ontouchstart={(e) => {
                        console.log('ontouchstart event:', e);
                        setLoanAmount(Number(e.target.value));  
                        setIntLoanAmout(Number(e.target.value));
                      }}
                      ontouchend={(e) => {
                        console.log('ontouchend event:', e);
                        setLoanAmount(Number(e.target.value));  
                        setIntLoanAmout(Number(e.target.value));
                      }}
                      ontouchmove={(e) => {
                        console.log('ontouchmove event:', e);
                        setLoanAmount(Number(e.target.value));  
                        setIntLoanAmout(Number(e.target.value));
                      }}
                    ></toolcool-range-slider> 


                      <div className="justifycontentSpacebetn flex_row managemargin">
                        <span className="">₹ 1000</span>
                        {maxLoanAmount ? (
                          <span>
                            ₹{" "}
                            {maxLoanAmount}
                          </span>
                        ) : (
                          <span>₹ 2,00,000</span>
                        )}
                      </div>
                    </div>
                  </div>
                </div>

                {repayment_date?.length > 0 ? (
                <div className="cardstructurerepay mt-20 heightrepaycard pd-l-r-zero container">
                  <span className="loanamountText marginfixx  ml-10 mt-16">
                    Select Repayment Date
                  </span>
                  <div className="custom-dropdown-container">
      <div className="custom-dropdown" onClick={() => setIsRepaymentOpen(!isRepaymentOpen)}>
        {selectedDate ? moment(selectedDate).format("DD/MM/YYYY") : "Select Date"}
        <span className={`arrow ${isOpen ? "open" : ""}`}></span>
      </div>
      {isRepaymentOpen && (
        <div className="custom-dropdown-menu">
          {repayment_date.map((item, index) => (
            <div
              key={index}
              className="custom-dropdown-item outlinegeneral"
              onClick={() => handleDateSelect(item)}
            >
              {moment(item).format("DD/MM/YYYY")}
            </div>
          ))}
        </div>
      )}
    </div>
                </div>
              ) : (
                ""
              )}
                {repayment_date?.length > 0 ?  <div className="repaymentdisclaimer flex_row loanrepaydisclaimermarginfix">
                  <img
                    className="disclaimerimgapplyloanmarginfix"
                    style={{ marginRight: 13, marginLeft: 13 }}
                    width={16}
                    height={16}
                    src={DisclaimerImg}
                  ></img>
                  <p className="selectrepaymentdatedisclaimercolour mb-7">
                  Over 90% of people select repayment date as their salary
                  date.
                  </p>
                </div> 
                :
                <div style={{marginBottom:"20px"}}></div>
                }
               

                <div
                  onClick={() => {
                    if (loanAmount && repayDate) {
                      setPayday_visible(!payday_visible);
                      handleGetLoanCalculation(loanAmount, repayDate);
                      handleCalculation();
                    }
                  }}
                  className="cardSeeCalculation  mb-20 container"
                >
                  <div className="seecalculationpadding">
                    <div className="justifycontentSpacebetn flex_row ">
                      <a  className="transformfixt">
                        See calculations
                      </a>
                      <img
                        onClick={() => {
                          if (loanAmount && repayDate) {
                            setPayday_visible(!payday_visible);
                            handleCalculation();
                          }
                        }}
                        width={24}
                        height={24}
                        style={{marginRight:"25px"}}
                        src={Downward}
                      ></img>
                    </div>
                  </div>
                  {payday_visible && loan_type === "P" ? (
                    <div className="seecalculationpaddingfix">
                      <div className="toggle rounded-10 card-height-small w-100 mx-auto bg-white ">
                        <div className="d-flex flex-column  justify-content-between">
                          <div className="pt-0 pb-0">
                            <table className="emi_table">
                              <tr>
                                <td style={{ marginRight: 20 }}>Repayment</td>
                                <td>
                                  ₹
                                  {repayment_amount
                                    .toString()
                                    .replace(/\B(?=(\d{3})+(?!\d))/g, ",") ||
                                    "NA"}
                                </td>
                              </tr>
                              <tr>
                                <td>Interest(per day)</td>
                                {loanCalculations?.roi}%
                              </tr>
                              <tr>
                                <td>Processing Fee </td>₹
                                {loanCalculations?.processing_fee}
                             
                              </tr>
                              <tr>
                                <td>GST On Processing fee</td>₹
                                {loanCalculations?.gst_on_processing_fee}
                               
                              </tr>
                              <tr>
                                <td>Total Processing fee</td>₹
                                {loanCalculations?.total_processing_fee}
                               
                              </tr>
                              <tr >
                                <td >Total Disbursal Amount</td>₹
                                {loanCalculations?.disbursed_amount}
                               
                              </tr>
                              <tr>
                                <td>Repayment Date</td>
                                <td>
                                  {repayDate
                                    ? moment(repayDate).format("DD-MM-YYYY")
                                    : "NA"}
                                </td>
                              </tr>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                  ) : payday_visible && loan_type !== "P" ? (
                    <div className="seecalculationpaddingfix">
                      {spinner ? (
                        <Spinner
                          radius={30}
                          color={"#333"}
                          stroke={2}
                          visible={true}
                        />
                      ) : (
                        <div className="toggle card-height-small w-100 mx-auto bg-white outlinegeneral">
                          <div className="d-flex flex-column mb-20 justify-content-between">
                            <div className="pt-0 pb-0">
                              <table className="emi_table">
                                <thead>
                                  <tr>
                                    <td className="kfsfontheading" style={{paddingRight: 40 , paddingBottom:10}}>EMI</td>
                                    <td className="kfsfontheading" style={{paddingRight: 45, paddingBottom:10}}>Due Date</td>
                                    <td className="kfsfontheading" style={{paddingRight: 0, paddingBottom:10}}>Repayment</td>
                                  </tr>
                                </thead>
                                {emiList.map((finalEmi, index) => (
                                  <tr key={index}>
                                    <td className="kfsfont kfsmidfix"  style={{paddingBottom: 10}} >{index + 1}</td>
                                    <td className="kfsfont "  style={{paddingBottom: 10}}>
                                      {finalEmi?.due_date}
                                      {/* {moment(finalEmi?.due_date).format(
                                        "MM-DD-YYYY"
                                      )} */}
                                    </td>
                                    <td className="kfsfontt kfsmidfix2" style={{paddingBottom: 10}}>
                                     <span className="kfsfontrupee">₹</span> 
                                      {finalEmi?.repayble_amount
                                        .toString()
                                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                                    </td>
                                  </tr>
                                ))}
                              </table>
                            </div>
                          </div>
                        </div>
                      )}

                      <div className="toggle rounded-10 card-height-small w-100 mx-auto bg-white mb-20 outlinegeneral">
                        <div className="d-flex flex-column justify-content-between">
                          <div className="pt-0 pb-0">
                            <table className="emi_table">
                              <tr>
                                <td className="kfsfont pt-15 kfspadding15">Interest(per day)</td>
                                <td className="kfsfontt mr-177">
                               
                                    {loanCalculations?.roi}%
                                
                                </td>
                              </tr>
                              <tr>
                                <td className="kfsfont kfspadding15">Processing fee </td>
                                <span className="kfsfontt kfspadding15"><span className="kfsfontrupee">₹</span> {loanCalculations?.processing_fee}</span>
                              </tr>
                              <tr>
                                <td className="kfsfont kfspadding15">GST On Processing fee </td>
                                <span className="kfsfontt kfspadding15"><span className="kfsfontrupee">₹</span> 
                                {loanCalculations?.gst_on_processing_fee}</span>
                              </tr>
                              <tr>
                                <td className="kfsfont kfspadding15">Total Processing fee</td>
                                <span className="kfsfontt kfspadding15">
                                <span className="kfsfontrupee">₹</span> 
                                {loanCalculations?.total_processing_fee}</span>
                              </tr>
                              <tr>
                                <td style={{paddingBottom: 15}} className="kfsfont">Total Disbursal Amount</td>
                                <span className="kfsfontt">
                                <span className="kfsfontrupee">₹</span> 
                                {loanCalculations?.disbursed_amount}</span>
                              </tr>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                  ) : (
                    ""
                  )}
                </div>

                <div className="cardSeeCalculation  pd-l-r-zeroNew  container">
                  <div>
                    <span
                      
                      className="loanamountText marginfixx  ml-10 mt-16"
                    >
                      Reason for Loan
                    </span>
                    {/* <select
                      className="borderhereloan managemarginreasonforloan"
                      onChange={(e) => saveReasonForLoan(e.target.value)}
                      value={loanReason || ""}
                    >
                      <option value="" disabled>
                        Select reason
                      </option>

                      {reasonList?.map((reason, index) => {
                        return (
                          <option key={index} value={reason}>
                            {reason}
                          </option>
                        );
                      })}
                    </select> */}

                      <div className={`custom-dropdown-container ${isReasonOpen ? 'dropdown-open' : ''}`}>
                        <div 
                          className="custom-dropdown mb-20" 
                          onClick={() => {
                            setIsReasonOpen(!isReasonOpen);
                            setIsOpen(false);
                          }}
                        >
                          <span>{selectedReason || "Select reason"}</span>
                          <div className={`arrow ${isReasonOpen ? 'open' : ''}`} />
                        </div>
                        {isReasonOpen ?
                        <div className={`custom-dropdown-menu-loanrepay `}>
                          {reasonList.map((reason, index) => (
                            <div 
                              key={index} 
                              className="custom-dropdown-item outlinegeneral " 
                              onClick={() => handleReasonSelect(reason)}
                            >
                              {reason}
                            </div>
                          ))}
                        </div>: ""}
                      </div>
                  </div>
                </div>

               


              </div>
            </div>
            <div className="text-center justifycontentcentre sticky-button-container">
                <div className="text-center justifycontentcentre">
                  {loan_type && loanAmount && loanReason && repayDate ? (
                    <div
                      onClick={() => {
                        if (toastLimit) {
                          setToastLimit(false);
                          submitForm();
                          setTimeout(() => {
                            setToastLimit(true);
                          }, 2000);
                        }
                      }}
                      className="GetNowBtnrepayvd continue_btn_margin"
                    >
                      Continue
                    </div>
                  ) : (
                    <div className="GetNowBtnrepayvd continue_btn_margin opacity-50">
                      Continue
                    </div>
                  )}
                </div>
                    </div>
          </div>
        )

      }
    </>
  );
};
const mapStateToProps = (state) => {
  return {
    user: state.user,
    userDetail: state.userDetail,
  };
};
export default withRouter(connect(mapStateToProps, {
  getRepaymentDate,
  applyForLoan,
  getDocumentStatus,
  getReasonForLoan,
  getLoanCalculation,
  create_ckyc,
})(ApplyLoan));
